import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppService } from './app.service';
import { httpOptions } from "../constants/http-options.constant";
import { OAuthProviderStatus, OAuthAuthorizeResponse } from '../models/oauth.class';

@Injectable({
  providedIn: 'root'
})
export class OAuthService {
  private _http = inject(HttpClient);
  private _appService = inject(AppService);

  private oauthUrl = this._appService.getServerBaseUrl + '/external-oauth';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  /**
   * Get list of available OAuth providers
   * @returns Observable with the list of providers
   */
  getProviders(): Observable<OAuthProviderStatus[]> {
    const url = `${this.oauthUrl}/providers`;
    return this._http.get<OAuthProviderStatus[]>(url, httpOptions).pipe(
      map(providers => providers.map(provider => new OAuthProviderStatus(provider)))
    );
  }

  /**
   * Authorize with a specific OAuth provider
   * @param provider The OAuth provider name
   * @returns Observable with the authorization response
   */
  authorize(provider: string): Observable<OAuthAuthorizeResponse> {
    const url = `${this.oauthUrl}/authorize/${provider}`;
    return this._http.get<OAuthAuthorizeResponse>(url, httpOptions).pipe(
      map(response => new OAuthAuthorizeResponse(response))
    );
  }
}